import { render } from "./Pwd.vue?vue&type=template&id=b17b1736"
import script from "./Pwd.vue?vue&type=script&lang=js"
export * from "./Pwd.vue?vue&type=script&lang=js"
script.render = render

export default script